import axios from '@/axios';

/**
 * Fetch article photos.
 *
 * @param {string}   eid    The ID of the entity.
 * @param {string[]} codes  The codes of the articles.
 * @param {"T"|"O"}  format Whether to fetch thumbnails (`T`) or originals (`O`).
 * @returns {{photo_id: number, photos: string[]}[]} A list of base64-encoded images.
 */
export async function getImagesByArticleCodes(eid, codes, format = 'T')
{
    const url = '/api/catalog/entity/{eid}/photos/{format}'
        .replace('{eid}', eid)
        .replace('{format}', format);

    const response = await axios.post(url, { codes });
    return response.data;
}

/**
 * Fetch short and long article descriptions.
 *
 * @param {string}   eid  The ID of the entity.
 * @param {string}   code The code of the article.
 * @param {string[]} lang The list of 2-character language codes to filter on.
 *                        An empty list means "all languages".
 * @returns {Promise<Record<string, {
 *     short_description: ?string,
 *     long_description:  ?string,
 * }>>}
 */
export async function getDescriptionByArticleCode(eid, code, lang = [])
{
    let url = `/api/catalog/entity/${eid}/article/${code}/description`;
    if(lang.length)
    {
        const params = new URLSearchParams();
        for(const l of lang)
        {
            params.append('lang[]', l);
        }
        url += '?' + params.toString();
    }

    const response = await axios.get(url);
    return response.data;
}
